<template>
  <div class="single-model models">
    <headerComponent></headerComponent>
    <div class="container position-relative mb-5">
      <div class="row">
        <div class="col-lg-4">
          <sidebarComponent></sidebarComponent>          
        </div>
        <div class="col-lg-8">

          <div class="card view-model" v-if="modelData">
              <div class="row model-details-actions">
                <div id="model-details-actions-id" class="col-12 mb-2 mt-2">
                  <button id="view-model-id" class="buttons button-one d-inline-flex flex-wrap justify-content-center align-items-center export-csv" @click="openViewer()"><i class="fa-solid fa-eye"></i><div class="w-100 text-center text-model-details-icon">view</div></button>
                  <!--<button class="buttons button-two d-inline-flex apply-template" >Delete</button>-->
                  <button id="edit-settings-id" class="buttons button-one d-inline-flex flex-wrap justify-content-center align-items-center export-csv"  @click="openSettings()"><i class="fa-solid fa-gears"></i><div class="w-100 text-center text-model-details-icon">settings</div></button>
                  <span id="comments-model-id" style="display:inline-block!important;"  tabindex="0" data-bs-toggle="tooltip" title="Available for Premium or Business Plans" data-bs-trigger="click">
                    <!-- <button class="buttons button-one d-inline-flex flex-wrap justify-content-center align-items-center export-csv" @click="openComments()" :disabled="commentsDisabled()">
                      <i class="fa-solid fa-comment" style="width:100%"></i>
                      <div class="text-center w-100 text-model-details-icon">Comments</div>
                    </button> -->
                  </span>
                  <span id="embed-model-id" style="display:inline-block" tabindex="0" data-bs-toggle="tooltip" title="Available for Business Plans" data-bs-trigger="click">
                    <button class="buttons button-two d-inline-flex flex-wrap justify-content-center align-items-center back" @click="embedModel()" :disabled="embedDisabled()">
                      <i class="fa-solid fa-code" style="width:100%"></i>
                      <div class="text-center w-100 text-model-details-icon">Embed</div>
                    </button>
                  </span>
                  <button id="share-model-id" class="buttons button-two d-inline-flex flex-wrap justify-content-center align-items-center back" @click="socialShare()">
                    <i class="fa-sharp fa-solid fa-share-nodes"></i>
                    <div class="text-center w-100 text-model-details-icon">Share</div>
                  </button>
                  <button id="delete-model-id" class="buttons button-two d-inline-flex delete-models flex-wrap align-items-center justify-content-center" @click="deleteAll()">
                    <i class="fa-solid fa-trash"></i>
                    <div class="text-center w-100 text-model-details-icon">Delete</div>
                  </button>
                  <button id="go-back-id" class="buttons button-two d-inline-flex delete-models flex-wrap align-items-center justify-content-center back" @click="backPage()">
                    <i class="fa-solid fa-rotate-left"></i>
                    <div class="text-center w-100 text-model-details-icon">Back</div>
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4">
                  <img :src="modelData.thumbnail" v-if="modelData.thumbnail" class="card-img-top">
                  <div class="square full-width" v-else></div>
                  <div class="tags-list">
                    <span v-for="tag,index in modelData.tags" :key="index" class="inner-model" @click="deleteTag(tag)">{{tag}} <span class="delete">X</span></span>
                  </div>
                </div>
                <div class="col-lg-8">
                  
                  <div class="card-body">
                    <table class="table-responsive table">
                      <tbody>
                        <tr>
                          <td><strong>Name</strong>: </td>
                          <td class="text-break">{{modelData.modelName}}</td>
                        </tr>
                        <tr>
                          <td><strong>Size</strong>: </td>
                          <td class="text-break">{{formatBytes(modelData.modelSize)}}</td>
                        </tr>
                        <tr>
                          <td><strong>Date</strong>: </td>
                          <td class="text-break">{{modelData.date}}</td>
                        </tr>
                        <tr>
                          <td><strong>Tags</strong></td>
                          <td>
                            <div class="d-flex flex-nowrap">
                            <vue3-simple-typeahead
                              id="tagslist"
                              placeholder="Write at least 3 letters..."
                              :items="tagsList"
                              :minInputLength="3"
                              @selectItem="selectItemEventHandler"
                              @onInput="onInputEventHandler"
                              ref="searchTags"
                            >
                            </vue3-simple-typeahead> 
                            <button class="buttons button-one" v-if="!tagFound" @click="saveTagsList">ADD</button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
          </div> 
        </div>
      </div>
    </div>
    <div class="loader" v-if="!loaded">
      <div>
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
      </div>
    </div>

   
    <div class="card view-model embed-view position-fixed export-csv-data-modal" style="width: 24rem;z-index:999;" v-if="showEmbedModel">
      <!-- for iframe embedding -->
      <button type="button" class="btn-close" aria-label="Close" @click="showEmbedModel = false"></button>
      <div class="card-body">
      <div class="mb-4">
        <div class="form-group col-12 mb-2">
          <label>Choose an iFrame dimension</label>
          <select v-model="embed.sizes" class="form-select">
            <option value="400x300">400x300</option>
            <option value="560x420">560x420</option>
            <option value="640x480">640x480</option>
            <option value="960x720">960x720</option>
            <option value="1280x800">1280x800</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div v-if="embed.sizes == 'other'">
          <label>Or specify a custom size:</label>
          <div class="form-group col-12 mb-2">
            <input v-model="embed.width" class="form-control" placeholder="width" type="number">
          </div>
          <div class="form-group col-12 mb-2">
            <input v-model="embed.height" class="form-control" placeholder="height" type="number">
          </div>
        </div>
      </div>
      <label>Copy and Paste the following code in the &lt;body&gt; section of your html page, wherever you want the model to appear:</label>
      <div  style="font-size:12px; border:1px solid #ccc; padding:5px; max-height:200px; overflow-y:auto">
        <code>
          {{showEmbedModelSizes()}}
        </code>
      </div>
      </div>

    </div>

    <div class="card view-model embed-view position-fixed export-csv-data-modal" style="width: 20rem;z-index:999;" v-if="showShareSocial">
      <!-- for sharing -->
      <button type="button" class="btn-close" aria-label="Close" @click="closeSocialShare()"></button>
      <div class="card-body sharing-social-icons">
        <label>Copy URL:</label><br>
        <div class="input-group input-group-sm mb-3">
          <input v-model="modelData.url" @focus="$event.target.select()" type="text" class="form-control" ref="URLinput" readonly >
          <span class="input-group-text"><button id="url-button-id" class="buttons button-three flex-wrap align-items-center justify-content-center" @click="copyToClipboard()" data-bs-toggle="tooltip" title="Copy" data-bs-trigger="hover">{{ urlButtonText }}</button></span>
        </div>
        
        <label>Or share it with:</label><br>
        <ShareNetwork
          network="facebook"
          :url="modelData.url"
          :title="modelData.modelName"
        >
          <i class="fa-brands fa-facebook"></i>
        </ShareNetwork>
        <ShareNetwork
          network="twitter"
          :url="modelData.url"
          :title="modelData.modelName"
        >
          <i class="fa-brands fa-twitter"></i>
        </ShareNetwork>
        <ShareNetwork
          network="linkedin"
          :url="modelData.url"
          :title="modelData.modelName"
        >
          <i class="fa-brands fa-linkedin"></i>
        </ShareNetwork>
        <ShareNetwork
          network="reddit"
          :url="modelData.url"
        >
          <i class="fa-brands fa-reddit"></i>
        </ShareNetwork>
        <ShareNetwork
          network="messenger"
          :url="modelData.url"
          :title="modelData.modelName"
        >
          <i class="fa-brands fa-facebook-messenger"></i>
        </ShareNetwork>
        <ShareNetwork
          network="email"
          :url="modelData.url"
          :title="modelData.modelName"
        >
          <i class="fa-solid fa-envelope"></i>
        </ShareNetwork>
        <ShareNetwork
          network="telegram"
          :url="modelData.url"
          :title="modelData.modelName"
        >
          <i class="fa-brands fa-telegram"></i>
        </ShareNetwork>
        <ShareNetwork
          network="whatsapp"
          :url="modelData.url"
          :title="modelData.modelName"
        >
          <i class="fa-brands fa-whatsapp"></i>
        </ShareNetwork>
      </div>

    </div>
    <footerComponent></footerComponent>
  </div>
  <v-tour name="myTour" :steps="steps" :options="{ highlight: true }" :callbacks="myCallbacks"></v-tour>
</template>
<script>
/* eslint-disable */ 
import sidebarComponent from '../components/Sidebar.vue'
import commonProps from '../common/common.js'
import headerComponent from '../components/Header.vue'
import footerComponent from '../components/Footer.vue'
import axios from 'axios'
import '@/assets/scss/models-list.scss'
import { Tooltip } from 'bootstrap/dist/js/bootstrap.esm.min.js'
const common = new commonProps()
/* eslint-enable */
export default {
  name:'model-details',
  components: {
    sidebarComponent,
    headerComponent,
    footerComponent
  },
  data() {
    return {
      modelTagsList:[],
      modelData:{},
      tagsList:[],
      selectedTag:{},
      embed:{
        sizes:'400x300'
      },
      tagFound:false,
      showEmbedModel:false,
      showShareSocial:false,
      loaded:false,
      notValidCommentsExt: [
        "dxf",
        "dwg"
      ],
      fileExt:'',
      subscription:{data:{subscription_type:0}},
      disabled:true,
      steps: [
          {
            target: '#view-model-id',
            content: 'View the model',
            params: {
              placement: 'bottom', 
              enableScrolling: false 
            }
          },
          {
            target: '#edit-settings-id',
            content: 'Change logo, colors, lights, units and more...',
            params: {
              placement: 'bottom', 
              enableScrolling: false 
            }
          },
          // {
          //   target: '#comments-model-id',
          //   content: 'Create comments, markups and invite people to collaborate',
          //   params: {
          //     placement: 'bottom', 
          //     enableScrolling: false 
          //   }
          // },
          {
            target: '#embed-model-id',
            content: 'Get the Iframe code to embed the model in external websites',
            params: {
              placement: 'bottom', 
              enableScrolling: false 
            }
          },
          {
            target: '#share-model-id',
            content: 'Share the model with your favourite social',
            params: {
              placement: 'bottom', 
              enableScrolling: false 
            }
          },
          {
            target: '#delete-model-id',
            content: 'Delete the model and all its data, including backgrounds, markups and comments',
            params: {
              placement: 'bottom', 
              enableScrolling: false 
            }
          },
          {
            target: '#go-back-id',
            content: 'Go back to the model list',
            params: {
              placement: 'bottom', 
              enableScrolling: false 
            }
          },
          {
            target: '#tagslist_wrapper',
            content: 'Add tags to easily identify your models',
            params: {
              placement: 'bottom' ,
              enableScrolling: false 
            }
          }
        ],
      myCallbacks: {
        onSkip: this.stopProductTour,
        onFinish: this.stopProductTour
      },
      urlButtonText:'Copy'
    }
  },
  mounted () {
    this.getModelDetails()
    this.getTagsList()
    window.scrollTo(0,0)
    
    axios .get(`${common.supervisorApi}rest/get_subscription_details`)
          .then(result => {
            if (result.data && !result.data.error) {
              this.subscription = result.data
              this.enableTooltips()
            }
          })

    axios .get(`${common.supervisorApi}users/message/nd`)
    .then(result => {
      if (result.data && !result.data.error) {
        if (result.data.data){ //null if no value
          if (result.data.data.message_account_details) {    
            if (result.data.data.message_account_details==='true'){
              this.$tours['myTour'].start()
            }                
          } else {
            this.$tours['myTour'].start()
          }
        } else {
          this.$tours['myTour'].start()
        }
      }
    })
    

  },
  methods : {
    socialShare() {
      if (this.$gtm.enabled()) {                            
        window.dataLayer?.push({
        'event' : 'openSharing'
      })}   
      this.showShareSocial = true
    },
    closeSocialShare() {
      this.showShareSocial = false
      this.urlButtonText='Copy'
    },
    copyToClipboard(){
      this.$refs.URLinput.focus()
      document.execCommand('copy')
      this.urlButtonText='Copied'
    },
    showEmbedModelSizes() {
      if (this.$gtm.enabled()) {                            
        window.dataLayer?.push({
        'event' : 'openEmbedding'
      })}   
      if (this.embed.sizes && this.embed.sizes != 'other') {
        this.embed.width = this.embed.sizes.toString().toLowerCase().split('x')[0]
        this.embed.height = this.embed.sizes.toString().toLowerCase().split('x')[1]
      }
      return `<iframe id='3dviewerplayer' type='text/html' width='${this.embed.width}' height='${this.embed.height}' src='${this.modelData.url}' frameborder='0' scrolling='no' allowfullscreen webkitallowfullscreen mozallowfullscreen><p>Your browser does not support iframes.</p></iframe>`;
    },
    embedModel() {
      this.showEmbedModel = true
    },
    commentsDisabled() {

      //check on file extension and subscription
      if (this.subscription.data.subscription_type!==0){
        return this.notValidCommentsExt.includes(this.fileExt)
      } else {
        return true
      }
    },
    embedDisabled() {
      //check on file extension and subscription
      if (this.subscription.data.subscription_type!==0 && this.subscription.data.subscription_type!==1){ //only Trial or Business
        return false
      } else {
        return true
      }
    },
    enableTooltips(){
      //run only when subscription has been read
      
      if (this.subscription.data.subscription_type == 0){ //free

        Array.from(document.querySelectorAll('#comments-model-id'))
          .forEach(tooltipNode => new Tooltip(tooltipNode))
        
        Array.from(document.querySelectorAll('#embed-model-id'))
          .forEach(tooltipNode => new Tooltip(tooltipNode))
      
      } else if (this.subscription.data.subscription_type == 1 ){ //premium
        
        Array.from(document.querySelectorAll('#embed-model-id'))
          .forEach(tooltipNode => new Tooltip(tooltipNode))
      }
      
    },

    backPage() {
      this.$router.push('/')
    },
    getModelDetails() {
      axios .get(`${common.supervisorApi}models/get_models_list/${this.$route.params.model_id}`)
      .then(result => {
        if (result.data && !result.data.error) {
          this.modelData = result.data.data.models[0]
          this.loaded = true
          this.fileExt = this.modelData.modelName.toLowerCase().split('.').pop()
        } 
      }) 
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    saveTagsList() {
      let modelTagsList = this.modelData.tags
      let isNewTerm = true;
      if (modelTagsList.includes(this.selectedTag.input)) {
        isNewTerm = false;
      }

      this.$refs.searchTags.clearInput()
      if (isNewTerm) 
        modelTagsList.push(this.selectedTag.input)
      const tag = {
        'tags' : modelTagsList, //array of tags
        'modelID':this.modelData.model_id
      }
      
      axios .post(`${common.supervisorApi}models/save_tags_list/`, tag)
            .then((result) => {
              if (result.data && !result.data.error) {
                this.$refs.searchTags.clearInput()
                this.getModelDetails()
              }
            })
      
    },
    deleteTag(tagName) {
      const index = this.modelData.tags.indexOf(tagName)
      this.modelData.tags.splice(index,1);
      
      const tag = {
        'tags': this.modelData.tags,
        'modelID': this.modelData.model_id
      }
      
      axios .post(`${common.supervisorApi}models/save_tags_list/`, tag)
            .then((result) => {
              if (result.data && !result.data.error) {
                this.$refs.searchTags.clearInput()
                this.getModelDetails()
              }
            })
    },
    onInputEventHandler(value) {
      this.selectedTag = value;
      if (this.tagsList && Object.values(this.tagsList).includes(value.input))
        this.tagFound = true
      else
        this.tagFound = false
    },
    selectItemEventHandler(event) {
      let modelTagsList = this.modelData.tags
      modelTagsList.push(event) 
      const tag = {
        'tags' : modelTagsList, //array of tags
        'modelID':this.modelData.model_id
      }
      this.$refs.searchTags.clearInput()
      axios .post(`${common.supervisorApi}models/save_tags_list/`, tag)
            .then((result) => {
              if (result.data && !result.data.error) {
                //this.$refs.searchTags.clearInput()
                this.getTagsList()
              }
            })
    },
    //return all tags list 
    getTagsList() {
      axios .get(`${common.supervisorApi}models/get_tags_list/`)
            .then(result => {
              if (result.data && !result.data.error) {
                Object.values(result.data.data)
                this.tagsList = Object.values(result.data.data)
              }
            })
    },
    deleteModel(modelID) {
      this.showModal = false
      axios .get(`${common.supervisorApi}rest/get_admin_token`)
            .then(result => {
              if (result.data && !result.data.error) {
                const token = result.data.data.token;
                axios .get(`${common.supervisorApi}rest/get_customer_id_by_email`)
                      .then(result => {
                        if (result.data && !result.data.error) {
                          const customerID = result.data.data.customer_id;
                          axios .delete(`${common.modelApi}?token=${token}&customerID=${customerID}&modelID=${modelID}`)
                                .then((result) => {
                                  if (result.data && result.data.success) {
                                    this.$swal.fire({
                                      icon:'success',
                                      text:`Model ID ${modelID} successfully deleted`,
                                      timer:1500,
                                      showConfirmButton:false
                                    }).then(() => {
                                      this.$router.push('/')
                                    })
                                  }
                                })
                        }
                      })
              }
            })
    },
    deleteAll() {
      let models = []
      this.modelData.checked = true
      models.push(this.modelData)    
      if (models.length){
        this.$swal.fire({
        title:'Are you sure you want to delete this model?',
        icon:'warning',
        type:"warning",
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: "No",
        showLoaderOnConfirm: true,
        preConfirm: () => {
          const data = {
            models:models
          }
         
          return axios .post(`${common.supervisorApi}models/bulk_delete_models`, data)
                .then(result => {
                 
                  return result
                })
        },
        allowOutsideClick: () => !this.$swal.isLoading(),
        }).then((result) => {
         
          if (result.isConfirmed) {
            if (result.value.data && !result.value.data.error && result.value.data.data.success) {
              this.$swal.fire('Success', result.value.data.data.message, 'success');
              this.$router.push('/')
            }
            if (result.value.data && result.value.data.error)
              this.$swal.fire('Error', result.value.data.message, 'error')
            
          }
        })
      }
    },
    stopProductTour() {
      axios .get(`${common.supervisorApi}users/message/nd/message_account_details/false`)
            .then(result => {
              if (result.data && !result.data.error) {
                //console.log(result.data) -- it is necessary here, cancel can cause build error
              }
            })
    },
    // openComments(){
    //   if (this.$gtm.enabled()) {                            
    //     window.dataLayer?.push({
    //     'event' : 'openComments'
    //   })}   
    //   window.open(this.modelData.url+'?comments=true', '_blank')
    // },
    openSettings(){
      if (this.$gtm.enabled()) {                            
        window.dataLayer?.push({
        'event' : 'openSettings'
      })}        
      window.open(this.modelData.url+'?settings=true', '_blank')
    },
    openViewer(){
      if (this.$gtm.enabled()) {                            
        window.dataLayer?.push({
        'event' : 'openViewer'
      })}  
      //window.open(this.modelData.url, '_blank')
      window.open(this.modelData.url+'?comments=true', '_blank')
    },
    getTime(){
      return new Date().getTime()
    }
  }
}
</script>
